import { request } from "../../utils/config"
import { product_product } from "./types/product"

export const GET_PRODUCTS = async (params) => {
  const response = await request({
    url: `Products`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_PRODUCTS = async (params) => {
  const response = await request({
    url: `products`,
    params: { ...params, PageSize: 1000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })

  return response.data
}

export const GET_PRODUCT_BARCODES = async (params) => {
  const response = await request({
    url: `Products/ProductByNameAndArticle`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_PRODUCT = async (id: string): Promise<product_product> => {
  const response = await request({
    url: `Products/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
